/**
 * Slugifies a string (lowercase, dash-separated).
 * - Used to build safe download filenames
 * - Used to derive ID-like strings (e.g. doc-type/visit-type IDs) from user-entered names
 */
export const toSlug = (str: string): string => {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};
